export enum FixBlockMode {
  MINI = "mini",
  FULL = "full"
}